import { RoleId } from '@shared/rbac/roles'

/** FE alias for shared `RoleId` — keeps call sites on the old name. */
export const RoleEnum = RoleId
export type RoleEnum = (typeof RoleId)[keyof typeof RoleId]

export const isRestrictedUser = (role: number | undefined): boolean =>
  role === RoleEnum.RESTRICTED

export const isClientAdminUser = (role: number | undefined): boolean =>
  role === RoleEnum.CLIENT

export const isViewOnlyUser = (role: number | undefined): boolean =>
  role === RoleEnum.VIEWER || role === RoleEnum.MARKETER_VIEW_ONLY
